module.exports = __webpack_public_path__ + "static/img/CAROLINA-OAK.5f0687d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CAROLINA-OAK.png
// module id = nkKh
// module chunks = 0